import { useIntl } from '@/intl'
import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore'
import { mqMax } from '@sunwebgroup/ui-components'
import { Button, IconButton } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { getTableData } from './selectors'
import { downloadCSV } from './utils'

const IconButtonStyled = styled(IconButton)`
  display: none;
  @media ${mqMax('primitives_breakpoint_s_max')} {
    display: inline-flex;
  }
`

const ButtonStyled = styled(Button)`
  @media ${mqMax('primitives_breakpoint_s_max')} {
    display: none;
  }
`

export function DownloadButton() {
  const intl = useIntl()
  const [tableData, tableName] = useGroupResponsibleStore(getTableData, intl)

  const handleDownload = () => {
    if (tableData.length) {
      downloadCSV(tableData, tableName)
    }
  }

  return (
    <>
      <ButtonStyled onClick={handleDownload} variant="secondary">
        {intl.formatMessage({ id: 'groups_responsible_download' })}
        <Button.Icon glyph="DocumentWithArrowDownToLine" />
      </ButtonStyled>
      <IconButtonStyled onClick={handleDownload} variant="secondary" glyph="DocumentWithArrowDownToLine" />
    </>
  )
}
